import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowRightIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.67569 4.42472C10.1313 3.9691 10.87 3.9691 11.3256 4.42472L20.0756 13.1747C20.5312 13.6303 20.5312 14.369 20.0756 14.8246L11.3256 23.5746C10.87 24.0302 10.1313 24.0302 9.67569 23.5746C9.22008 23.119 9.22008 22.3803 9.67569 21.9247L17.6007 13.9997L9.67569 6.07463C9.22008 5.61902 9.22008 4.88033 9.67569 4.42472Z"
      fill="white"
    />
  </SvgIcon>
);
